import { gql } from '@apollo/client';

export const CUSTOMER_ACCESS_TOKEN = gql`
  mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
    customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`;

export const REFRESH_CUSTOMER_ACCESS_TOKEN = gql`
  mutation customerAccessTokenRenew($customerAccessToken: String!) {
    customerAccessToken @client @export(as: "customerAccessToken")
    customerAccessTokenRenew(customerAccessToken: $customerAccessToken) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      userErrors {
        field
        message
      }
    }
  }
`;

export default {};
